import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormGroupDirective, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {ObjektAdresseComponent} from 'src/app/home-layout/objekte/objekt-adresse/objekt-adresse.component';
import {AdresseModels} from 'src/app/models/adresse-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissFieldBase} from '../../fields/swiss-field-base';

@Component({
  selector: 'app-address-form-field-container',
  templateUrl: './address-form-field-container.component.html',
  styleUrls: ['./address-form-field-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddressFormFieldContainerComponent implements OnInit {
  @Input() swissField!: SwissFieldBase<any>;
  @Input() formGrp!: UntypedFormGroup;

  private objektAdresseDialogInput?: ObjektModels.ObjektAdresseDialogInput;
  private addressType: number = 1; /* CUSTOMER */
  private readonly adressTypes?: AdresseModels.AddressTypes[];
  public adressTypeDesc: string = '';

  formControl = new UntypedFormControl(this.swissField); // Gemäss Video

  constructor(
    private rootFormGroup: FormGroupDirective,
    private svcObjekte: ObjektDataService,
    public dialog: MatDialog
  ) {
    // FormGroup von überliegender Komponente abholen
    this.formGrp = this.rootFormGroup.control;
    this.adressTypes = this.svcObjekte.getLoadedAddressTypen();
  }

  ngOnInit(): void {
    if (this.swissField && this.adressTypes) {
      if (this.swissField.options.key === 'AdrBoxChoiceKunde') {
        this.addressType = 1;
        this.adressTypeDesc = this.adressTypes.find(x => x.addressTypeNumber === 1)?.description!
      }
      else if (this.swissField.options.key === 'AdrBoxChoiceRech') {
        this.addressType = 2;
        this.adressTypeDesc = this.adressTypes.find(x => x.addressTypeNumber === 2)?.description!
      }
      else if (this.swissField.options.key === 'AdrBoxChoiceArch') {
        this.addressType = 3;
        this.adressTypeDesc = this.adressTypes.find(x => x.addressTypeNumber === 3)?.description!
      }
      else if (this.swissField.options.key === 'AdrBoxChoiceLief') {
        this.addressType = 4;
        this.adressTypeDesc = this.adressTypes.find(x => x.addressTypeNumber === 4)?.description!
      }
    }
  }

  addAddress() {
    this.objektAdresseDialogInput = {
      objektAdresseZuord: {
        id: '00000000-0000-0000-0000-000000000000',
        objectID: '',
        addressType: this.addressType,
        addressContact: 0,
        adressNumber: 0,
        adressID: '',
      },
      blDoCheckUnique: false,
      blDisableAdrTypeSelect: true,
    };

    var dialogRef = this.dialog.open(ObjektAdresseComponent, {
      disableClose: true,
      width: '95%',
      data: this.objektAdresseDialogInput,
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          this.objektAdresseDialogInput!.objektAdresseZuord = result;
          // Objektzuordnung dem Feld zuweisen
          if (this.swissField.objektAdressZuordnungen) {
          } else {
            this.swissField.objektAdressZuordnungen! = [];
            this.swissField.objektAdressZuordnungen!.push(result);
          }

          this.svcObjekte
            .getAdressViewContent(
              this.objektAdresseDialogInput!.objektAdresseZuord
            )
            .subscribe({
              next: (res: any) => {
                if (res) {
                  this.swissField!.options.value = res;
                  this.formGrp.controls[
                    this.swissField!.options.key!
                  ].patchValue(res);
                  console.log('FormFeld abgefüllt', this.formGrp);
                }
              },
              error: (err: any) =>
                console.error('Fehler beim Ermitteln der AnzeigeAdresse', err),
            });
        }
      },
    });
  }

  removeAddress() {
    this.swissField.objektAdressZuordnungen = undefined;
    this.swissField.options!.value = '';
    this.formGrp.controls[this.swissField!.options.key!].patchValue('');
  }
}
